import Entity from './entity';
export default class Job extends Entity<number> {
  name: string;
}